import sharedData from "./lwn_data.json";

const data = sharedData;

export default data;
